import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SqlReport } from '../shared/models/reports/sql-report.model';
import { SqlReportResult } from '../shared/models/reports/sql-report-result.model';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/reports/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public getReports(): Observable<SqlReport[]> {
    return this.http.get<SqlReport[]>(`${this.apiUrl}`);
  }

  public executeReport(reportName: string, parameters: any): Observable<SqlReportResult> {
    return this.http.post<SqlReportResult>(`${this.apiUrl}${encodeURIComponent(reportName)}`, { parameters });
  }
}
